import AssessmentTrackMixin from '@/apps/assessment/mixins/assessment-track-mixin'
import RouterMixin from '@/apps/assessment/mixins/clazz-router-mixin'
import {
  getClazzList,
  getExamList as getClazzExamList,
  unitTestDelete
} from '@/apps/assessment/model/api'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import moment from 'moment'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { examDelete, getExamDelete, getExamList, getExamStatus } from '../model/api'
import { CLAZZ_PUB_COLUMNS, PUB_COlUMNS, PUBLISH_LIST } from '../model/list'

const DATEFORMAT = 'YYYY-MM-DD HH:mm'
const UCENTER = process.env.VUE_APP_UCENTER_DOMAIN || 'https://ucenter.test.17zuoye.net/'
const TAG_SETTING = [
  {
    text: '进行中',
    bg: '#F0F9ED',
    font: '#6AC54D',
    en: 'ONGOING'
  },
  {
    text: '已结束',
    bg: '#F3F5F9',
    font: '#4D5271',
    en: 'ENDED'
  },
  {
    text: '未上线',
    bg: '#E7E7FF',
    font: '#5D5BFF',
    en: 'NOT_ONLINE'
  },
  {
    text: '未发布',
    bg: '#FFF1EB',
    font: '#6AC54D',
    en: ''
  },
  {
    text: '未开始',
    bg: '#E7E7FF',
    font: '#5D5BFF',
    en: 'NOT_START'
  },
  {
    text: '',
    bg: '#F0F9ED',
    font: '6AC54D'
  },
  {
    text: '未打开',
    bg: '#FFF1EB',
    font: '#6AC54D',
    en: 'UNOPENED'
  },
  {
    text: '原始数据',
    bg: '#FFF1EB',
    font: '#6AC54D',
    en: 'RAW'
  }
]

const proSource = '班级测评列表'
const examType = 'independent'
const PUBLISH_ALREADY = { label: '已发布', value: 2 }
const UNPUBLISH = { label: '未发布', value: 1 }
@Component({ components: { SmallBtnSkeleton } })
export default class AssessmentClazzList extends Mixins(AssessmentTrackMixin, RouterMixin) {
  private columns = CLAZZ_PUB_COLUMNS
  private columnPub = PUB_COlUMNS
  private datasource = []
  private unPubData = []
  private subject: any = {}
  private clazzLevelList = []
  private publishList = PUBLISH_LIST
  private publishMethod: any = this.pb == '1' ? UNPUBLISH : PUBLISH_ALREADY
  private selectedStatus = []
  private selectedClazz = []
  private pagination = {
    current: 1,
    total: 0
  }
  private optionsLoading = true
  // 全部的groupId集合
  private gids: any[] = []
  private prefix =
    process.env && process.env.VUE_APP_PUBLIC_MAIN_URL
      ? process.env.VUE_APP_PUBLIC_MAIN_URL
      : 'http://www.test.17zuoye.net'

  private get supportSubjects() {
    let supportSubjects = this.$store.state.clazzSupportSubjects
    if (supportSubjects && supportSubjects.length > 0) {
      return [...supportSubjects]
    } else {
      return []
    }
  }

  private get defaultSubject() {
    return this.$route.query.subject
  }
  // publish-method
  private get pb() {
    return this.$route.query.pb
  }

  @Watch('supportSubjects', { immediate: true, deep: true })
  public onSupportSubjects(val) {
    if (this.defaultSubject) {
      this.subject = this.supportSubjects.find((n) => n.nick === this.defaultSubject)
    } else {
      if (val && val.length > 0) {
        this.subject = val[0]
      }
    }
  }

  public mounted() {
    this.getClazzList()
    this.columns.map(item => {
      item.title = ['examTypeName', 'startAt'].includes(item.dataIndex) &&
        this.$store.state.user_info && this.$store.state.user_info.regions && this.$store.state.user_info.regions.length &&
        this.$store.state.user_info.regions[2].code == 310112 ? item.title.replace('测评', '练习') : item.title
    })
    this.columnPub.forEach(item => {
      item.title = ['examTypeName', 'examStartTime'].includes(item.dataIndex) &&
        this.$store.state.user_info && this.$store.state.user_info.regions && this.$store.state.user_info.regions.length &&
        this.$store.state.user_info.regions[2].code == 310112 ? item.title.replace('测评', '练习') : item.title
    })
  }

  public processClazzNames(record): string {
    const level = record && record.clazzLevel
    const groupids = record && record.groupIds
    // 先找到年级，再根据groupids 确定班级
    if (this.clazzLevelList && this.clazzLevelList.length) {
      let clazzs: any[] = []
      const grade: any = this.clazzLevelList.find((m: any) => {
        return m.clazzLevel === level
      })
      for (let m of grade.clazzs) {
        if (groupids.indexOf(m && m.groupId) > -1) {
          clazzs = [...clazzs, m]
        }
      }
      return (clazzs && clazzs.length > 0 && clazzs.map((m: any) => m.fullName).join('、')) || ''
    } else {
      return ''
    }
  }

  public unPubEdit(id) {
    this.$router.push({
      path: '/clazz/publish',
      query: {
        subject: this.subject.nick,
        subject_id: this.subject.value,
        tid: id,
        f: encodeURIComponent(proSource)
      }
    })
  }

  public formateDate(date) {
    return moment(date).format(DATEFORMAT)
  }
  // 未发布 - 删除
  public unPubDeleteExam(id) {
    this.$confirm({
      title: '确定删除？',
      onOk: async () => {
        this.trackDelete({ Assessment_id: id })
        this.getExamDelete(id)
        // await this.getExamStatus(id, this.getExamDelete, this.getExamDelete2)
      },
      onCancel: () => {}
    })
  }
  public unPublic(id) {}
  public onStatusChange() {
    this.getClazzExamList(1)
  }
  public onClazzChange() {
    if (this.publishMethod.value === 1) {
      this.getExamList(1)
    } else {
      this.getClazzExamList(1)
    }
  }
  public tagColor(text) {
    if (text) {
      const reuslt = TAG_SETTING.find((item) => item.text === text)
      return reuslt
    } else {
      return TAG_SETTING[0]
    }
  }
  // 获取班级列表
  public async getClazzList() {
    try {
      this.optionsLoading = true
      const data: any = await getClazzList({ subject: this.subject.nick })
      if (data.success) {
        this.clazzLevelList = data.clazzList
        let gids: any[] = []
        for (let n of data.clazzList) {
          for (let m of n.clazzs) {
            gids = [...gids, m.groupId]
          }
        }
        this.gids = gids
        if (this.publishMethod.value === 1) {
          this.getExamList(1)
        } else {
          this.getClazzExamList(1)
        }
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  // 获取已发布班级测评列表
  public async getClazzExamList(page) {
    this.pagination.current = page
    const groupIds =
      this.selectedClazz && this.selectedClazz.length > 0 ? this.selectedClazz : this.gids
    const param = {
      groupIds: groupIds.join(','),
      subject: this.subject.nick,
      currentPage: page
    }
    const data: any = await getClazzExamList(param)
    if (data.success) {
      this.datasource = data.pageable.content
      this.pagination.total = data.pageable.totalElements
    } else {
      this.datasource = []
      this.pagination.total = 0
    }
  }

  // 获取试卷列表
  public async getExamList(page) {
    this.pagination.current = page
    const groupIds =
      this.selectedClazz && this.selectedClazz.length > 0 ? this.selectedClazz : this.gids

    try {
      const param = {
        subjectId: Number(this.subject.value),
        page,
        examType,
        groupIds
      }
      const data: any = await getExamList(param)
      if (data.success) {
        this.pagination.total = data.data.total
        this.unPubData = data.data.records
      } else {
        this.pagination.total = 0
        this.unPubData = []
      }
    } catch (e) {
      console.log(e)
    }
  }
  // 删除测评
  public async getExamDelete(id) {
    // 判断是不是最后一条，最后一条就page-1 看是不是第一页，第一页除外
    const l = this.unPubData && this.unPubData.length
    const data: any = await getExamDelete({ id })
    if (data.success) {
      if (this.pagination.current === 1) {
        this.getExamList(this.pagination.current)
      } else {
        if (l && l === 1) {
          this.getExamList(this.pagination.current - 1)
        }
      }
    }
  }
  public async getExamDelete2(examId) {
    const l = this.unPubData && this.unPubData.length
    const data: any = await unitTestDelete({ newExamId: examId })

    if (this.pagination.current === 1) {
      this.getExamList(this.pagination.current)
    } else {
      if (l && l === 1) {
        this.getExamList(this.pagination.current - 1)
      }
    }
  }
  public async examDelete(examId) {
    const l = this.datasource && this.datasource.length
    const data: any = await unitTestDelete({ newExamId: examId })
    if (data.success) {
      if (this.pagination.current === 1) {
        this.getClazzExamList(this.pagination.current)
      } else {
        if (l && l === 1) {
          this.getClazzExamList(this.pagination.current - 1)
        }
      }
    }
  }
  public onDeleteExam(examId) {
    this.$confirm({
      title: '确定删除？',
      onOk: () => {
        this.trackDelete({ Assessment_id: examId })
        this.examDelete(examId)
      },
      onCancel: () => {}
    })
  }
  public onEditExam(record) {
    this.$router.push({
      path: '/clazz/publish',
      query: {
        exam: record.newExamId,
        subject: this.subject.nick,
        f: encodeURIComponent(proSource)
      }
    })
  }
  // 未发布的删除需要先获取测评状态
  public async getExamStatus(id, method, method2) {
    try {
      const data: any = await getExamStatus({
        id
      })
      if (data.success) {
        if (data.data.status === 'RAW') {
          method(id)
        } else {
          method2(data.data.examId)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  // 选择学科
  public selectSubject(itm) {
    this.subject = itm
    this.selectedClazz = []
    if (this.publishMethod.value === 1) {
      this.getClazzList()
      this.getExamList(1)
    } else {
      this.getClazzList()
      this.getClazzExamList(1)
    }
  }
  //
  public selectPublishMethod(itm) {
    this.publishMethod = itm
    if (itm.value === 1) {
      this.getExamList(1)
    } else {
      this.getClazzExamList(1)
    }
  }
  public findProgress(record) {
    const preifx = process.env.VUE_APP_PUBLIC_MAIN_URL || 'https://www.test.17zuoye.net/'
    window.open(
      `${preifx}teacher/newexam/report/detail.vpage?clazzId=${record.clazzId}&newExamId=${record.newExamId}`
    )
  }
  // 表格分页切换
  public onTablechange(pagination) {
    const pager = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    if (this.publishMethod.value === 1) {
      this.getExamList(pagination.current)
    } else {
      this.getClazzExamList(pagination.current)
    }
  }
  // 点击设置班组信息
  public onClazzsSettingClick() {
    window.open(UCENTER + '/teacher/systemclazz/clazzindex.vpage?step=showtip')
  }
}
